








import { Vue, Component } from 'vue-property-decorator';
import { Page } from '@/components/Page.vue';

@Component({
  name: 'Users',
  components: {
    Page,
  },
})
export default class Users extends Vue {

}
